import React from "react";

const SettingsPage: React.FC = () => {
  return <div>Settings Page Content</div>;
};

export default SettingsPage;
